const init = (callback) => {
  document
    .querySelectorAll(".content.active a.gallery-item")
    .forEach(function (galleryItem) {
      galleryItem.onclick = function (e) {
        e.preventDefault();
        let paragraphID = e.target.closest(".card--section").id;
        callback(e.target.dataset.relatedEvidence, paragraphID);
      };
    });
};

export const inlineEvidence = (callback) => {
  document.addEventListener("click", function (e) {
    if (e.target && e.target.dataset.relatedEvidence) {
      e.preventDefault();
      let paragraphID = e.target.closest(".card--section").id;
      callback(e.target.dataset.relatedEvidence, paragraphID);
    }
  });
};

export default init;
